import { FindInPageOutlined as FindInPageOutlinedIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

interface CitationButtonProps {
  onClick: () => void;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium';
  'data-testid'?: string;
}

const CitationButton = ({
  onClick,
  'aria-label': ariaLabel = 'View source document',
  sx,
  size = 'small',
  'data-testid': dataTestId,
}: CitationButtonProps): JSX.Element => (
  <IconButton
    onClick={onClick}
    aria-label={ariaLabel}
    size={size}
    data-testid={dataTestId}
    sx={{
      color: 'primary.main',
      cursor: 'pointer',
      marginLeft: '6px',
      marginTop: '6px',
      ...sx,
    }}>
    <FindInPageOutlinedIcon />
  </IconButton>
);

export default CitationButton;
